import { useContext } from 'react';

import DesktopHeader from '~/components/Header/DesktopHeader';
import MobileHeader from '~/components/Header/MobileHeader';
import useWindowSize from '~/hooks/useWindowSize';
import AppContext from '~/contexts/AppContext';

function Header() {
  const { isMobile } = useContext(AppContext);
  const { width } = useWindowSize();

  if (isMobile || (width && width <= 768)) {
    return <MobileHeader />;
  }
  return <DesktopHeader />;
}

export default Header;
